import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  onSnapshot,
  orderBy,
  limit
} from "firebase/firestore";
import { db } from "../firebase";

const ChatList = ({ onSelectChat, selectedChatId }) => {
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const currentUserId = String(currentUser?.id);
  const currentUserfName = currentUser?.firstName || "";
  const currentUserlName = currentUser?.lastName || "";

  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUserId) return;

    const q = query(
      collection(db, "chats"),
      where("participants", "array-contains", currentUserId),
      orderBy("updatedAt", "desc")
    );

    const unsubscribe = onSnapshot(
      q,
      snapshot => {
        const list = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setChats(list);
        setLoading(false);
      },
      error => {
        // fallback if index missing
        const fallbackQ = query(
          collection(db, "chats"),
          where("participants", "array-contains", currentUserId)
        );

        onSnapshot(fallbackQ, snap => {
          const list = snap.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          setChats(list);
          setLoading(false);
        });
      }
    );

    return () => unsubscribe();
  }, [currentUserId]);

  // if (loading) return <p></p>;

  return (
    <>

      <div className="chatlt">
        <div className="chatltinner">
          <div className="chatltheading">Conversations</div>
          <div className="chatltbody">
            <div className="chatltsearch">
              <div className="inputgroup">
                <input type="text" className="form-control" placeholder="Search" name="" />
                <button className="theme-btn" type="button"><i class="icon icon-search m-0"></i></button>
              </div>
            </div>
            <div className="chatltbtm">
              <div className="tab-content mt-3" id="ChatTabContent">
                <div className="tab-pane fade show active" id="ChatReceived" role="tabpanel" aria-labelledby="ChatReceived-tab">
                  <div className="chatltlists">
                    {loading && (
                      <div className="text-center my-3">
                        <p className="mt-2">Loading chats...</p>
                      </div>
                    )}

                    {!loading && chats.length === 0 && (
                      <p className="text-muted text-center">No chats yet</p>
                    )}


                    {chats.map(chat => {
                      // 🔹 determine name to show
                      let displayName = "User";

                      if (chat.lastMessageFromId === currentUserId) {
                        displayName = chat.lastMessageToName || "User";
                      } else {
                        displayName = chat.lastMessageFromName || "User";
                      }

                      // fallback if above fields not present
                      if (!chat.lastMessageFromId) {
                        displayName =
                          chat.participants?.length === 2
                            ? "Chat"
                            : "User";
                      }

                      const otherUserId = chat.participants?.find(
                        p => String(p) !== currentUserId
                      );
                      return (
                        <button
                          type="button"
                          key={chat.id}
                          className={`chatltlistbx ${selectedChatId === chat.id ? "active" : ""
                            }`}
                          onClick={() =>
                            onSelectChat({
                              chatId: chat.id,
                              otherUserId,
                              otherUserfName: displayName.split(" ")[0],
                              otherUserlName: displayName.split(" ").slice(1).join(" ")
                            })

                          }
                        >
                          <div class="chatltlistimg">
                            <span className="chatavatar">{displayName.charAt(0)}</span>
                            <span class="onlinebadge"></span>
                          </div>
                          <div className="chatltlistct">
                            <div className="d-flex justify-content-between">
                              <h5>{displayName}</h5>
                            </div>
                            <p>{chat.lastMessage || "Open chat"}</p>
                          </div>
                        </button>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default ChatList;
